import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-clickable-cell',
  templateUrl: './clickable-cell.component.html',
  styleUrls: ['./clickable-cell.component.scss'],
  standalone: false
})
export class ClickableCellComponent {
  @Input() text: string = '';
  @Input() row: any;

  @Output() clicked = new EventEmitter<any>();

  onClick() {
    this.clicked.emit(this.row);
  }
}
